const projects = [
  {
    id: "1",
    title: "JDG - Trading Card Game Mobile",
    description: "JDG – Trading Card Game Mobile is a strategic one-on-one card battler for Android, adapting the popular Joueur du Grenier TCG with intuitive, turn-based gameplay. Build custom decks from 30 unique cards (including up to 5 shiny cards, no duplicates) and use five card types to outplay your opponent and reduce their life stars from 30 to 0.",
    technologies: [
      {name: "Unity", icon: "unity"},
      {name: "C#", icon: "csharp"}
    ],
    imageSrc: "https://camo.githubusercontent.com/a6bdaafbd433f6068d0853e70a2deba41f34c0fe892abfc2731a8e2a88898593/68747470733a2f2f6c68332e676f6f676c6575736572636f6e74656e742e636f6d2f6f4f46396e776c526c3535574579696c68794f634e35745f56397a474331723251756d53365378634f354a687a64796e5a4364506b5154496a64565a386b7173384277",
    link: "https://github.com/PLR2388/JDGMobileGame"
  },
  {
    id: "2",
    title: "Notify me Here",
    description: "Notify Me Here! lets you send points of interest from your phone to your Wear OS watch, with a short description, and get notified when you’re nearby. Perfect for discovering places you plan to visit or simply remembering to stop at the grocery store when you’re close.",
    technologies: [
      {name: "Kotlin", icon: "kotlin"},
      {name: "Android", icon: "android"}
    ],
    imageSrc: "https://play-lh.googleusercontent.com/M7Bj070hNEnQr_38n1hbowk0NDoz2x0bbQdrU8qbvRnXINTe1PfcR4c0eGjVRrN_3qkn=w480-h960-rw",
    link: "https://play.google.com/store/apps/details?id=fr.wonderfulappstudio.notifymehere"
  }
];

export default projects;
